<template>
    <div class="bg-secondary d-flex justify-content-between">
        <scrollable-widget
                arrow-bg-color="var(--secondary)"
                arrow-fg-color="var(--gray-dark)"
        >
            <b-navbar>
                <b-navbar-nav>
                    <b-nav-item
                            v-for="item in links"
                            :key="item.name"
                            :to="item.route"
                            v-if="hasAccess(item)"
                            exact
                            exact-active-class="active"
                            class="mr-2"
                    >
                        {{ item.label }}
                    </b-nav-item>
                </b-navbar-nav>
            </b-navbar>
        </scrollable-widget>
    </div>
</template>

<script>
import ScrollableWidget from '@/components/Widgets/ScrollableWidget';

export default {
  name: 'Subnav',
  components: {
    ScrollableWidget,
  },
  props: {
    links: {
      required: true,
      type: Array,
    },
  },
  methods: {
    hasAccess(item) {
      if (item.hasAccess === undefined) {
        return true;
      }

      return item.hasAccess();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
